import { render } from "./RecommendAdApplicationsView.vue?vue&type=template&id=5caf6620&scoped=true"
import script from "./RecommendAdApplicationsView.vue?vue&type=script&lang=js"
export * from "./RecommendAdApplicationsView.vue?vue&type=script&lang=js"

import "./RecommendAdApplicationsView.vue?vue&type=style&index=0&id=5caf6620&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5caf6620"]])

export default __exports__